import { render } from "./AppUploader.vue?vue&type=template&id=41fadf06"
import script from "./AppUploader.vue?vue&type=script&lang=js"
export * from "./AppUploader.vue?vue&type=script&lang=js"

import "./AppUploader.vue?vue&type=style&index=0&id=41fadf06&lang=sass"
script.render = render

export default script